import { ChevronRight } from "lucide-react";

const STAGE_META = {
  sent: { label: "Sent", hint: "waiting on an open", tone: "text-white/60", ring: "border-white/15" },
  opened: { label: "Opened", hint: "they've seen it — call", tone: "text-sky-200", ring: "border-sky-400/40" },
  called: { label: "Called", hint: "conversation started", tone: "text-amber-200", ring: "border-amber-400/40" },
  set_up: { label: "Set up", hint: "closest to a load", tone: "text-emerald-300", ring: "border-emerald-400/50" },
};

export function PacketPipeline({ pipeline, onJump }) {
  if (!pipeline || pipeline.total === 0) return null;
  return (
    <div className="mt-4 pt-3 border-t border-white/[0.06]" data-testid="packet-pipeline">
      <div className="text-[11px] uppercase tracking-widest text-white/50 font-bold mb-2">Broker pipeline · {pipeline.total} packet{pipeline.total === 1 ? "" : "s"}</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {pipeline.stages.map((st, i) => {
          const m = STAGE_META[st.key];
          return (
            <div key={st.key} className={`relative rounded-lg border ${m.ring} bg-white/[0.02] px-2.5 py-2 min-h-[74px]`} data-testid={`packet-pipeline-stage-${st.key}`}>
              <div className="flex items-baseline justify-between gap-2">
                <span className={`text-[11px] font-bold uppercase tracking-wider ${m.tone}`}>{m.label}</span>
                <span className={`font-display text-xl font-bold leading-none ${st.count ? m.tone : "text-white/25"}`} data-testid={`packet-pipeline-count-${st.key}`}>{st.count}</span>
              </div>
              <div className="text-[10px] text-white/35 mb-1.5">{m.hint}</div>
              <div className="flex flex-wrap gap-1">
                {st.brokers.map((b) => (
                  <button key={b.id} type="button" onClick={() => onJump?.(b.id)} title={b.lost ? "Not onboarding / wrong contact" : "Jump to this packet"}
                    className={`max-w-[120px] truncate rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${b.lost ? "border-white/10 text-white/30 line-through" : `${m.ring} ${m.tone} hover:bg-white/[0.06]`}`}
                    data-testid={`packet-pipeline-chip-${b.id}`}>
                    {b.name}
                  </button>
                ))}
                {st.count > st.brokers.length && <span className="text-[10px] text-white/35">+{st.count - st.brokers.length} more</span>}
              </div>
              {i < pipeline.stages.length - 1 && <ChevronRight className="hidden sm:block absolute -right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-white/20" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
